import React from 'react';
import { Zap } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function DiscountBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-gradient-to-r from-alphaGold to-[#e6b835] py-[50px] px-5 text-center text-white" data-id="element-93" data-mp="re0yncwuaqwi">
      <div className="max-w-[1100px] mx-auto" data-id="element-94" data-mp="wddtajtyd29n">
        <h2 className="text-[clamp(2rem,5vw,3.5rem)] font-black uppercase tracking-[3px] mb-2.5 flex items-center justify-center gap-3" data-id="element-95" data-mp="wc2r2og5o2kn">
          <Zap className="w-8 h-8 md:w-10 md:h-10" data-id="element-96" data-mp="3nx55ydd87j8" /> 20% OFF — HOY ÚNICAMENTE
        </h2>
        <p className="text-[1.1rem] opacity-90 max-w-[600px] mx-auto" data-id="element-97" data-mp="8n9r8gwexakr">
          Esta oferta es por tiempo limitado. El stock se agota rápido y el
          precio vuelve a normal sin previo aviso.
        </p>

        <div className="flex justify-center gap-5 mt-[25px] flex-wrap" data-id="element-98" data-mp="3c49rivk2ogxy">
          <div className="bg-black/30 rounded-md py-[15px] px-[20px] min-w-[80px] text-center" data-id="element-99" data-mp="3c1xbinxvkgnj">
            <span className="text-[2.2rem] font-black block leading-none" data-id="element-100" data-mp="3h1077hrytaiu">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-[0.7rem] tracking-[2px] uppercase opacity-80 mt-1 block" data-id="element-101" data-mp="giozt7sdhoq3">
              Horas
            </span>
          </div>
          <div className="bg-black/30 rounded-md py-[15px] px-[20px] min-w-[80px] text-center" data-id="element-102" data-mp="bqnqnuqi4e4a">
            <span className="text-[2.2rem] font-black block leading-none" data-id="element-103" data-mp="6t5e7ud9zgrj">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-[0.7rem] tracking-[2px] uppercase opacity-80 mt-1 block" data-id="element-104" data-mp="3t0vla8tmmu2v">
              Minutos
            </span>
          </div>
          <div className="bg-black/30 rounded-md py-[15px] px-[20px] min-w-[80px] text-center" data-id="element-105" data-mp="3ozjysc61uoyw">
            <span className="text-[2.2rem] font-black block leading-none" data-id="element-106" data-mp="3k1i8p7a7hpdx">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-[0.7rem] tracking-[2px] uppercase opacity-80 mt-1 block" data-id="element-107" data-mp="1i8ki7i3wj8w5">
              Segundos
            </span>
          </div>
        </div>
      </div>
    </div>;
}